import React from 'react'
import { object } from 'prop-types'
import { StyledLabel, StyledValue } from './styles/style'

const ParagraphCkeditorFieldText = ({ data }) => {
	const { field, value } = data

	const div = document.createElement('div')
	div.innerHTML = value
	let text = div.textContent || div.innerText || ''

	return (
		<div>
			{field.label && <StyledLabel>{field.label}:</StyledLabel>}
			<StyledValue>{text}</StyledValue>
		</div>
	)
}

export default ParagraphCkeditorFieldText

ParagraphCkeditorFieldText.propTypes = {
	data: object,
}
